import { render, staticRenderFns } from "./item_tpl.vue?vue&type=template&id=cb4de3d4&scoped=true"
import script from "./item_tpl.vue?vue&type=script&lang=js"
export * from "./item_tpl.vue?vue&type=script&lang=js"
import style0 from "./item_tpl.vue?vue&type=style&index=0&id=cb4de3d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4de3d4",
  null
  
)

export default component.exports